// extracted by mini-css-extract-plugin
export default {"input":"ManageCreditRadioField_input__58euz","text":"ManageCreditRadioField_text__i0hhk"};